'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _addClassName = require('../utils/add-class-name');

var _addClassName2 = _interopRequireDefault(_addClassName);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _copyProps = require('../utils/copy-props');

var _copyProps2 = _interopRequireDefault(_copyProps);

var _namespaceOptions = require('../utils/namespace-options');

var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstToggleButton = function (_VstComponent) {
  _inherits(VstToggleButton, _VstComponent);

  function VstToggleButton(props) {
    _classCallCheck(this, VstToggleButton);

    var _this = _possibleConstructorReturn(this, (VstToggleButton.__proto__ || Object.getPrototypeOf(VstToggleButton)).call(this, props));

    _this._toggleButton = _this._toggleButton.bind(_this);
    return _this;
  }

  _createClass(VstToggleButton, [{
    key: '_toggleButton',
    value: function _toggleButton(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }
      this.props.onToggle(e);
    }
  }, {
    key: '_getCSS',
    value: function _getCSS() {
      return {
        '&.on': {
          backgroundColor: this._theme(7)
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          on = _props.on,
          onText = _props.onText,
          offText = _props.offText;

      var classes = 'boolean-toggle no-highlight noButton';
      var rule = (0, _glamor.css)(this._getCSS());

      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)((0, _namespaceOptions2.default)('vst', this.props.options), classes, { disabled: disabled }, { on: on }, rule.toString()));
      props = (0, _copyProps2.default)(props, ['options', 'on', 'onToggle', 'offText', 'onText']);
      return _react2.default.createElement(
        'button',
        _extends({
          'aria-pressed': on,
          onClick: this._toggleButton
        }, props),
        _react2.default.createElement('div', { className: 'toggle-dot' }),
        _react2.default.createElement(
          'span',
          { className: 'toggle-text' },
          _react2.default.createElement(
            'span',
            { 'aria-hidden': !on },
            onText
          ),
          _react2.default.createElement(
            'span',
            { 'aria-hidden': on },
            offText
          )
        )
      );
    }
  }]);

  return VstToggleButton;
}(_VstComponent3.default);

exports.default = VstToggleButton;


VstToggleButton.propTypes = {
  on: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onToggle: _propTypes2.default.func,
  offText: _propTypes2.default.string,
  onText: _propTypes2.default.string,
  'aria-describedby': _propTypes2.default.string,
  'aria-label': _propTypes2.default.string,
  style: _propTypes2.default.object
};

VstToggleButton.defaultProps = {
  on: false,
  onToggle: function onToggle() {},
  disabled: false,
  offText: '',
  onText: '',
  'aria-describedby': '',
  'aria-label': '',
  style: {}
};


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstToggleButton.js
 **/